import React from "react";
import { Progress } from "antd";

const stats = [
  {
    title: "Ball Possession",
    home: 40,
    away: 52
  },
  {
    title: "Total Passes",
    home: 40,
    away: 52
  },
  {
    title: "Shots On Target",
    home: 40,
    away: 30
  },
  {
    title: "Total Saves",
    home: 10,
    away: 40
  },
  {
    title: "Off-Sides",
    home: 30,
    away: 40
  },
  {
    title: "Corner Kicks",
    home: 50,
    away: 20
  },
  {
    title: "Yellow Cards",
    home: 30,
    away: 40
  },
  {
    title: "Red Cards",
    home: 0,
    away: 0
  },
  {
    title: "Goal Kicks",
    home: 15,
    away: 8
  }
];


const StatsBox = () => (
  <>
    {stats.map((stat, index) => (
      <div className="mt-10" key={index}>
        <Stats title={stat.title} home={stat.home} away={stat.away} />
      </div>
    ))}
  </>
);

const Stats = ({title, home, away}) => {
  return (
    <>
      <div className="text-center stat-box">
        <p className="text-base">{title}</p>
        <div className="inline w-1/2 p-2">
          <Progress strokeLinecap="square" percent={home} strokeWidth={14} />
        </div>
        <div className="inline w-1/2 p-2">
          <Progress strokeLinecap="square" percent={away} strokeWidth={14} />
        </div>
      </div>
    </>
  );
};


export default StatsBox;